import { Layout, theme } from "antd";
import React from "react";
import LoginComponent from "./auth/LoginComponent";

const { Header, Sider, Content, Footer } = Layout;
function LandingPage(){
    const {
        token: { colorBgContainer },
      } = theme.useToken();

    return (<Layout className="site-layout" style={{ minHeight: '100vh' }}>
        <Header 
          >Header</Header>
        <Layout>
          <Content style={{
              margin: '24px 16px',
              padding: 24,
              background: colorBgContainer,
            }}>Content</Content>
          <Sider>
            <LoginComponent/>
          </Sider>
        </Layout>
        <Footer>Footer</Footer>
      </Layout>);
}

export default LandingPage;